<template>
  <el-container class="bimManage">
    <el-aside class="leftAside">
      <div class="leftHead">
        <el-dropdown trigger="click"  @command="addPlanHandler">
          <span class="el-dropdown-link">
            <el-button size="small" type="primary" plain :disabled="!treeObj.folderId">新建</el-button></span>
          <el-dropdown-menu slot="dropdown" >
            <!--   节点下面 不允许添加分类 -->
            <el-dropdown-item command="分类" :disabled="!treeObj.folderId||treeObj.folderType=='1'"> 新增分类 </el-dropdown-item>
            <!-- 第一层  节点下面 不允许添加节点 -->
            <el-dropdown-item command="节点" :disabled="!treeObj.folderId||treeObj.parentId=='0'||treeObj.folderType=='1'"> 新增节点 </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 第一层   不允许编辑 -->
        <el-button size="small" :disabled="!treeObj.folderId||treeObj.parentId=='0'" @click="editPlanHandler">编辑</el-button>
        <!-- 第一层   不允许删除 -->
        <el-button size="small" type="danger" plain :disabled="!treeObj.folderId||treeObj.parentId=='0'||!treeObj.folderType" @click="delePlanHandler">删除</el-button>
      </div>
      <div class="leftContain">
        <el-tree :data="treeList" :props="defaultProps" show-checkbox @check="handleCheckChange" :check-strictly="true"
        default-expand-all :expand-on-click-node="false" node-key="folderId" ref="tree" :highlight-current="true"
        @current-change="currentOrgChangeHandler">
          <template #default="{ data }">
            <div class="treeContent">
              <img :src="stageImg"  alt="阶段图片" v-if="data.folderType=='2'" class="imgCont"/>
              <img :src="classImg"  alt="分类图片" v-else-if="data.folderType=='0'" class="imgCont"/>
              <img :src="nodeImg"  alt="节点图片" v-else-if="data.folderType=='1'" class="imgCont"/>
              <img :src="rvtImg"  alt="模型图片" v-else class="imgCont"/>
              <div class="content">
                <span class="title" :title="data.folderName">{{ data.folderName }}</span>
                <i class="el-icon-circle-plus" @click="addFile" v-if="data.folderType==1"></i>
                <i class="el-icon-delete-solid" @click="deleRvtHandler(data)" v-if="!data.folderType"></i>
              </div>
            </div>
          </template>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="rightContain" v-if="selectList.length>0">
      <model :obj="modelForm" :key="updateKey"></model>
    </el-main>
    <el-main class="uncheckNode" v-else>
      <div class="tips"><i class="el-icon-warning"></i>请选择模型 </div>
    </el-main>
    <model-dialog ref="modelDialog" v-if="modelDialog" :nodeId="treeObj.folderId" @childMethod="getTreeList"></model-dialog>
  </el-container>
</template>

<script>
import bimManage from "@/xgzdService/bimManage-service"
import model from "@/views/modelPro/index.vue"
import modelDialog from "./modelDialog.vue"
import { mapState } from "vuex";
export default {
  inject: ['reload'],
  components:{model,modelDialog},
  data(){
    return{
      treeData:[],
      defaultProps: {
        children: 'childList',
        label: 'folderName'
      },
      treeList:[],
      selectList:[],
      img:require('@/CommonDP/assets/暂无数据.png'),
      modelForm:{
        fileIds:"",
        fileNames:"",
        prjId:"",
        prjName:"",
        rvtVersion:"",
        parentId:"",
        noNeedIssue:"yes"
      },
      updateKey:1,
      treeObj:{
        folderId:"",
        folderName:"",
        folderType:"",
        parentId:""
      },
      stageImg:require(`@/views/assets/stage.png`),
      nodeImg:require(`@/views/assets/node.png`),
      classImg:require(`@/views/assets/class.png`),
      rvtImg:require(`@/CommonDP/assets/projectMg/rvt.svg`),
      modelDialog:false
    }
  },
  mounted(){
    this.getTreeList()
  },
   computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
  },

  methods:{
    async getTreeList(){
      this.modelDialog=false;
      this.selectList=[];
      const{prjInfo:{prjId},enterpriseId,getTreeData,formatData}=this;
      const {data}=await bimManage.getFolderTree(prjId,enterpriseId);
      //将分类、节点前面的多选框去掉
      this.treeList=await formatData(data);
      //循环获取节点下面的文件
      await getTreeData(this.treeList);
      this.treeList=this.treeList.map((item)=>{
        if(item.parentId==="0")  item.folderType = "2"
        return item
      });
      console.log(this.treeList);
      if (this.treeList.length > 0) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeList[0].folderId);
          this.currentOrgChangeHandler(this.treeList[0])
        });
      }
    },
    //将所有选择框去掉
    formatData(params){
      let data = params;
      data.map((item) => {
        item.disabled = true;
        if(!item.childList)item.childList=[];
        if(item.childList&&item.childList.length>0)this.formatData(item.childList)
      });
      return data;
    },

    async getTreeData(array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].folderType === '1') {
          const {data}=await bimManage.getMoDelByNodeId(array[i].folderId);
          const list=data.map((item)=>{
            return{
              folderId:item.modeId,
              folderName:item.modeName,
              fileType:item.modelFileType,
              fileVersion:item.modelFileVersion,
              parentId:item.modelFileVersion,
              nodeId:array[i].folderId
            }
          })
          //后端没去重，只能我这里过滤一下
          const res = new Map();
          array[i].childList = list.filter( (a) => !res.has(a.folderId) && res.set(a.folderId, 1) );
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(array[i].childList);
        }
      }
      return array;
    },
    currentOrgChangeHandler(val) {
     this.treeObj=val;
    },
    handleCheckChange(data, currentChecked){
      this.selectList=currentChecked.checkedNodes;
      const a=this.selectList.some((e) => this.selectList.filter((e1) => e1.nodeId !== e.nodeId).length >= 1)
      if(a) {
        this.$message.warning("请选择同一节点下的模型") ;
        this.selectList=[];
        return;
      }
      this.updateKey++;
      const {prjId, prjName}=this.prjInfo;
      this.openModels(currentChecked.checkedNodes, prjId, prjName);
    },


    openModels(rows, prjId, prjName){
      this.modelForm.fileIds = rows.map((item) => item.folderId).join();
      this.modelForm.fileNames = rows.map((item) => item.folderName).join();
      this.modelForm.parentId = rows[0]?.parentId;
      this.modelForm.rvtVersion = rows.map((item) => item.fileVersion).join();
      this.modelForm.prjId=prjId;
      this.modelForm.prjName=prjName;
    },
    addPlanHandler(type){
      const {prjInfo:{prjId},enterpriseId ,treeObj:{folderId}}=this;
      this.$prompt(`请输入${type}名称`, `添加${type}名称`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: `请输入${type}名称`,
        inputErrorMessage: `请输入除空格外的15文字以内的${type}名称`,
        inputPattern: /^\S{1,15}$/,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'confirm') {
            const form = {
              folderName: inputValue,
              enterpriseId,
              parentId:folderId,
              folderType:type=="分类"?0:1,
              prjId,
            };
            try {
              const result = await bimManage.addBIMManangerFolder(form);
              if (result.result === '0') {
                this.$message({ type: 'success', message:` ${type}添加成功 `});
                this.getTreeList();
                done();
              }
            } catch (e) {
              this.$message({ type: 'error', message: `${type}添加失败` });
            }
          } else {
            done();
          }
        },
      });
    },
    editPlanHandler(){
      const {folderId,folderType,folderName}=this.treeObj;
      const type=folderType=="0"?"分类":"节点"
      this.$prompt(`请输入${type}名称`, `编辑${type}名称`, {
        inputPlaceholder: `编辑${type}名称`,
        inputValue: folderName,
        inputErrorMessage: `请输入除空格外的15文字以内的${type}名称`,
        inputPattern: /^\S{1,15}$/,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'cancel') done();
          else {
            try {
              await bimManage.updateBIMManangerFolder(folderId,inputValue);
              await this.$message({ type: 'success', message: `${type}编辑成功` });
              await  this.getTreeList();
              done();
            } catch (e) {
              this.$message({ type: 'error', message: `${type}编辑失败` });
            }
          }
        },
      });
    },
    async delePlanHandler(){
      const {folderId,folderType,folderName}=this.treeObj;
      const type=folderType=="0"?"分类":"节点";
      this.$confirm(`确定删除${type}${folderName}?`, '警告', { type: 'warning', })
      .then(() => bimManage.delBIMManangerFolder(folderId))
      .then(() => { this.$message({ type: 'success', message: `删除${folderName}成功` }) })
      .then(() => { this.getTreeList() });
    },
    async deleRvtHandler(row){
      const {folderId,folderName,nodeId}=row;
      this.$confirm(`确定删除${folderName}?`, '警告', { type: 'warning', })
      .then(() => bimManage.delModelById(nodeId,[folderId]))
      .then(() => { this.$message({ type: 'success', message: `删除${folderName}成功` }) })
      .then(() => { this.getTreeList() });
    },
    addFile() {
      this.modelDialog = true;
      this.$nextTick(() => {
        this.$refs.modelDialog.showDialog();
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.bimManage{
  width: 100%;
  height: 100%;
  .leftAside{
    height: 100%;
    width: 20% !important;
    border-right: 1px Solid #DDE2EE;
    background :#fff;
    .leftHead{
      padding: 10px 15px;
      border-bottom: 1px Solid #DDE2EE;
      .el-dropdown{
        margin-right: 10px;
      }
    }
    .leftContain{
      height: calc(100% - 80px);
      margin-top:12px;
      overflow: auto;
      .treeContent{
        display:flex;
        align-items:center;
        width: 100%;
        .content{
          display:flex;
          justify-content: space-between;
          width:100%;
          padding-right: 10px;
        }
        .title{
          width:150px;
          overflow:hidden; 
          white-space:nowrap;
          text-overflow:ellipsis;
        }
        .el-icon-circle-plus,.el-icon-delete-solid{
          font-size: 16px;
          color:#909EB4
        }
        .imgCont{
          margin-right: 6px;
        }
      }
      /deep/.el-checkbox__input.is-disabled .el-checkbox__inner{
        display: none;
      }
    }
  }
  .rightContain{
    padding: 0;
    height: 100%;
    width: 80%;
  }
  .uncheckNode {
    height: 100%;
    width: 100%;
    background :#fff;
    position: relative;
    .tips{
      position: absolute;
      top: 100px;
      left:0;
      right:0;
      margin: 0 auto;
      width: 340px;
      height: 60px;
      background: #EEF3FD;
      line-height: 60px;
      font-size: 15px;
      color: #5587F0;
      .el-icon-warning{
        margin: 0 20px;
      }
    }
  }
}
</style>
